<template>
  <div class="wrapper">
    <side-bar backgroundColor="blue">
      <sidebar-link :to="urlWithRedirect('/ppe_ee/home')">
        <i class="nc-icon nc-chart-pie-35"></i>
        <p>Accueil EE</p>
      </sidebar-link>
      <sidebar-link :to="urlWithRedirect('/ppe_ee/account')">
        <i class="nc-icon nc-circle-09"></i>
        <p>Mon compte</p>
      </sidebar-link>

      <!-- <sidebar-link to="/ppe_ee/company">
        <i class="nc-icon nc-badge"></i>
        <p>Ma société</p>
      </sidebar-link> -->

      
      <template slot="bottom-links">
        <sidebar-link class="active" to="/admin" v-if="isAdminVisible()">
          <i class="nc-icon nc-alien-33"></i>
          <p>Administration</p>
        </sidebar-link>
      </template>
    </side-bar>
    <div class="main-panel">
      <top-navbar></top-navbar>

      <dashboard-content @click="toggleSidebar">

      </dashboard-content>

      <content-footer></content-footer>
    </div>
  </div>
</template>
<style lang="css">

</style>
<script>
  import TopNavbar from './PPETopNavbar.vue'
  import ContentFooter from './ContentFooter.vue'
  import DashboardContent from './Content.vue'

  import common from '../pages/common/pages.js'

  export default {
    components: {
      TopNavbar,
      ContentFooter,
      DashboardContent,
    },
    methods: {

      ...common.methods,

      toggleSidebar () {
        if (this.$sidebar.showSidebar) {
          this.$sidebar.displaySidebar(false)
        }
      },

      isAdminVisible() {
        return this.$usermanager.isAdmin() //|| this.$usermanager.isImpersonating()
      }
    }
  }

</script>
